import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Loader } from '../components/ui/Loader';
import { ServerCard } from '../components/temporary-numbers/ServerCard';
// import { VoiceCallTab } from '../components/temporary-numbers/VoiceCallTab';
import { useGetServersQuery } from '../store/api/temporaryNumbersApi';
import { useGetDisabledServersQuery } from '../store/api/proxiesApi';

const TEMP_SERVER_TO_KEY: Record<number, string> = {
  1: "smspool",
  4: "durianRcs",
  5: "textverified_temp",
  6: "pvadeals6",
};

export function TemporaryNumbersPage() {
  const { t } = useTranslation();
  // const [showVoice, setShowVoice] = useState(false);
  const { data, isLoading, error } = useGetServersQuery();
  const { data: disabledData } = useGetDisabledServersQuery();
  const disabledServers: string[] = useMemo(
    () => disabledData?.data?.disabledServers || [],
    [disabledData],
  );

  if (isLoading) {
    return (
      <div className="min-h-screen relative">
        <div className="container mx-auto px-4 py-16 content-overlay">
          <div className="max-w-6xl mx-auto">
            <div className="flex justify-center items-center py-12">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen relative">
        <div className="container mx-auto px-4 py-16 content-overlay">
          <div className="max-w-6xl mx-auto">
            <div className="card-glass rounded-2xl shadow-2xl p-8 text-center">
              <h2 className="text-2xl font-heading font-bold text-danger mb-4">
                {t('errors.network')}
              </h2>
              <p className="text-neutral-medium font-body mb-6">
                {'data' in (error as { data?: { message?: string } })
                  ? ((error as { data?: { message?: string } })?.data?.message || t('errors.network'))
                  : t('errors.network')}
              </p>
              <Link
                to="/"
                className="inline-block px-6 py-2 bg-brand-accent text-brand-primary font-heading font-semibold rounded-lg hover:shadow-lg hover:shadow-brand-accent/50 transform hover:scale-105 transition-all duration-300"
              >
                {t('common.back')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const servers = data?.data.servers || [];

  return (
    <div className="min-h-screen relative">
      <div className="container mx-auto px-4 py-16 content-overlay">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-8 text-center animate-slide-up">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-accent mb-4">
              {t('temporaryNumbers.title')}
            </h1>
            <p className="text-neutral-medium text-lg font-body">
              {t('temporaryNumbers.subtitle')}
            </p>
          </div>

          {/* Servers List (SMS) */}
          <div className="card-glass rounded-2xl shadow-2xl p-6 md:p-8 mb-6 animate-scale-in">
            <h2 className="text-2xl font-heading font-semibold text-neutral-light mb-6">
              {t('temporaryNumbers.servers.title')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {servers.map((server) => (
                <ServerCard key={server.serverId} server={server} disabled={disabledServers.includes(TEMP_SERVER_TO_KEY[server.serverId])} />
              ))}
            </div>
          </div>

          {/* Quick Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/temporary-numbers/list"
              className="px-6 py-3 bg-brand-accent text-brand-primary font-heading font-semibold rounded-lg hover:shadow-lg hover:shadow-brand-accent/50 transform hover:scale-105 transition-all duration-300 text-center"
            >
              {t('temporaryNumbers.list.title')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

